var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkOn = function SvgBookmarkOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#01C88D",
    viewBox: "0 0 17 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#01C88D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 3.16A2.16 2.16 0 0 1 3.16 1h10.8a2.16 2.16 0 0 1 2.16 2.16v17.28l-7.56-3.78L1 20.44z"
  })));
};
export default SvgBookmarkOn;